module.exports = __webpack_public_path__ + "img/bear8.bb31fd06.svg";